export const mapBackendToForm = (data) => {
  if (!data) return {};

  const stripSeconds = (time) => {
    if (!time) return "";
    const parts = time.split(":");
    return parts.length >= 2 ? `${parts[0].padStart(2, "0")}:${parts[1]}` : time;
  };

  return {
    ...data,
    fasting_confirmation: !!data.fasting_confirmation,
    covid_screening: !!data.covid_screening,
    blood_transfusion_consent: !!data.blood_transfusion_consent,
    imaging_tests_reviewed: !!data.imaging_tests_reviewed,
    all_lab_results_verified: !!data.all_lab_results_verified,
    cardiac_clearance: !!data.cardiac_clearance,
    pre_anaesthetic_medication_given: !!data.pre_anaesthetic_medication_given,
    patient_sedation_level: !!data.patient_sedation_level,
    anaesthesiologist_clearance: !!data.anaesthesiologist_clearance,
    surgical_instruments_ready: !!data.surgical_instruments_ready,
    ot_sterilization_check: !!data.ot_sterilization_check,
    blood_products_available: !!data.blood_products_available,
    guardian_consent: !!data.guardian_consent,
    anaesthesia_consent: !!data.anaesthesia_consent,
    antibiotics_given: !!data.antibiotics_given,
    anti_coagulants_stopped: !!data.anti_coagulants_stopped,
    skin_prep_completed: !!data.skin_prep_completed,
    pre_surgical_clothing_checked: !!data.pre_surgical_clothing_checked,
    blood_units_reserved1: !!data.blood_units_reserved1,
    final_physician_approval: !!data.final_physician_approval,
    time: stripSeconds(data.time),
    covid_screening_date: data.covid_screening_date ? new Date(data.covid_screening_date).toISOString().slice(0, 16) : "",
    fasting_last_time: data.fasting_last_time ? new Date(data.fasting_last_time).toISOString().slice(0, 16) : "",
    consent_date_time: data.consent_date_time ? new Date(data.consent_date_time).toISOString().slice(0, 16) : "",
    antibiotics_time: data.antibiotics_time ? new Date(data.antibiotics_time).toISOString().slice(0, 16) : "",
    entry_date_time: data.entry_date_time ? new Date(data.entry_date_time).toISOString().slice(0, 16) : "",
  };
};

export const mapFormToBackend = (formData) => {
  // Exclude 'name' — display-only patient name field, not a DB column
  const { name: _name, ...rest } = formData;
  return {
    ...rest,
    hospital_id: 1,
    fasting_confirmation: formData.fasting_confirmation ? 1 : 0,
    covid_screening: formData.covid_screening ? 1 : 0,
    blood_transfusion_consent: formData.blood_transfusion_consent ? 1 : 0,
    imaging_tests_reviewed: formData.imaging_tests_reviewed ? 1 : 0,
    all_lab_results_verified: formData.all_lab_results_verified ? 1 : 0,
    cardiac_clearance: formData.cardiac_clearance ? 1 : 0,
    pre_anaesthetic_medication_given: formData.pre_anaesthetic_medication_given ? 1 : 0,
    patient_sedation_level: formData.patient_sedation_level ? 1 : 0,
    anaesthesiologist_clearance: formData.anaesthesiologist_clearance ? 1 : 0,
    surgical_instruments_ready: formData.surgical_instruments_ready ? 1 : 0,
    ot_sterilization_check: formData.ot_sterilization_check ? 1 : 0,
    blood_products_available: formData.blood_products_available ? 1 : 0,
    guardian_consent: formData.guardian_consent ? 1 : 0,
    anaesthesia_consent: formData.anaesthesia_consent ? 1 : 0,
    antibiotics_given: formData.antibiotics_given ? 1 : 0,
    anti_coagulants_stopped: formData.anti_coagulants_stopped ? 1 : 0,
    skin_prep_completed: formData.skin_prep_completed ? 1 : 0,
    pre_surgical_clothing_checked: formData.pre_surgical_clothing_checked ? 1 : 0,
    blood_units_reserved1: formData.blood_units_reserved1 ? 1 : 0,
    final_physician_approval: formData.final_physician_approval ? 1 : 0,
    time: formData.time || null,
    fasting_last_time: formData.fasting_last_time || null,
    covid_screening_date: formData.covid_screening_date || null,
    consent_date_time: formData.consent_date_time || null,
    antibiotics_time: formData.antibiotics_time || null,
  };
};
